import { Alert } from '@mui/material';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import SimpleModal from 'components/SimpleModal';
import { useCallback } from 'react';

export const useFetchDataToIntegrationServerFromAgentWarning = () => {
  const { openModal } = useDynamicModal();

  const openFetchDataToIntegrationServerFromAgentWarning = useCallback(
    (args: { onConfirm: () => void }) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return (
            <SimpleModal
              onClose={toggle}
              open
              onConfirm={args.onConfirm}
              closeOnConfirm
              Body={
                <Alert severity="warning">
                  Fetching data older than 2 years will put a heavy load on the server and may
                  affect data sync times for other customers.
                </Alert>
              }
            />
          );
        },
      });
    },
    [openModal],
  );

  return {
    openFetchDataToIntegrationServerFromAgentWarning,
  };
};
